import React, { useContext } from "react"

export const ShowSearchContext = React.createContext()

export const useSearchContext = () => {
    return useContext( ShowSearchContext )
}